import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PlayFillInTheBlankQuestion from './playFillInTheBlankQuestion';

import { clearData, loadData, nextQuestion } from '../../actions/diagnostics.js';
import { clearDisplayMessageAndError } from '../../actions/display';
import fillInBlankActions from '../../actions/fillInBlank';
import massEditActions from '../../actions/massEdit';
import {
  massEditDeleteResponses,
  submitMassEditConceptResults,
  submitMassEditFeedback
} from '../../actions/responses';
import { FillInBlankQuestion, TestFillInBlankQuestionContainer } from '../../../Shared';
import ResponseComponentWrapper from '../questions/responseRouteWrapper.jsx';

const DiagnosticTestComponent = ({ dispatch, fillInBlank, match, playDiagnostic }) => {
  const testQuestionID = match.params.questionID;
  const testQuestion = fillInBlank?.data?.[testQuestionID];
  const { currentQuestion } = playDiagnostic || {};

  return (
    <TestFillInBlankQuestionContainer
      actions={{
        clearData,
        loadData,
        nextQuestion
      }}
      currentQuestion={currentQuestion ? currentQuestion.data : null}
      dispatch={dispatch}
      PlayComponent={PlayFillInTheBlankQuestion}
      question={testQuestion}
      questionID={testQuestionID}
      questionKey="data"
    />
  );
}

const FillInBlankQuestionContainer = ({ dispatch, display, fillInBlank, massEdit, match, playDiagnostic }) => {
  const { questionID } = match.params;
  const question = fillInBlank ? fillInBlank.data[questionID] : null;
  const handleEditQuestion = (questionUID, data) => {
    dispatch(fillInBlankActions.submitQuestionEdit(questionUID, data));
  };

  return (
    <FillInBlankQuestion
      actions={{
        clearDisplayMessage: clearDisplayMessageAndError,
        clearResponses: massEditActions.clearResponsesFromMassEditArray,
        deleteAll: massEditDeleteResponses,
        removeResponse: massEditActions.removeResponseFromMassEditArray,
        submitConceptResults: submitMassEditConceptResults,
        submitFeedback: submitMassEditFeedback
      }}
      basePath="fill-in-the-blanks"
      dispatch={dispatch}
      displayError={display?.error}
      displayMessage={display?.message}
      editQuestionAction={handleEditQuestion}
      hasReceivedData={fillInBlank.hasreceiveddata}
      massEdit={massEdit}
      question={question}
      questionID={questionID}
      ResponseComponent={ResponseComponentWrapper}
      TestComponent={(routeProps) => (
        <DiagnosticTestComponent
          {...routeProps}
          dispatch={dispatch}
          fillInBlank={fillInBlank}
          playDiagnostic={playDiagnostic}
        />
      )}
      useRelativePaths={false}
    />
  );
}

function select(props) {
  return {
    display: props.display,
    fillInBlank: props.fillInBlank,
    massEdit: props.massEdit,
    playDiagnostic: props.playDiagnostic
  };
}

export default withRouter(connect(select)(FillInBlankQuestionContainer));
